import { ApplicationRef, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { register } from 'swiper/element/bundle';
import { firstValueFrom } from 'rxjs';
import { filter, first, timeout } from 'rxjs/operators';

if (environment.production) {
  enableProdMode();
}

try {
  register();
} catch (err) {
  // safe fallback — log but don't block bootstrap
  console.warn('Swiper register failed (browser):', err);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { ngZoneEventCoalescing: true })
  .then(async (modRef) => {
    const appRef = modRef.injector.get(ApplicationRef);

    // 1) Wait until Angular becomes stable (first full change detection cycle)
    await firstValueFrom(appRef.isStable.pipe(filter(Boolean), first(), timeout(6000))).catch(() =>
      console.warn('App did not stabilize in 6s, continuing...')
    );

    // 2) Wait for critical web fonts to be ready (ignore failures)
    try {
      const fontsReady = (document as any).fonts?.ready;
      if (fontsReady && typeof fontsReady.then === 'function')
        await Promise.race([fontsReady, new Promise((r) => setTimeout(r, 1200))]);
    } catch {
      /* ignore */
    }

    // 3) Remove the hydration class on the next frame to avoid visual jumps
    requestAnimationFrame(() => {
      const root = document.documentElement;
      if (root.classList.contains('hydrating')) root.classList.remove('hydrating');
    });
  })
  .catch(console.error);
